import moveLane from './moveLane.json'
import voteCard from './voteCard.json'
import createLane from './createLane.json'
import deleteLane from './deleteLane.json'
import createCard from './createCard.json'
import updateCard from './updateCard.json'
import deleteCard from './deleteCard.json'
import createEvent from './createEvent.json'
import deleteEvent from './deleteEvent.json'
import createEntity from './createEntity.json'
import updateEntity from './updateEntity.json'
import deleteEntity from './deleteEntity.json'
import createCommand from './createCommand.json'
import updateCommand from './updateCommand.json'
import createDomainEventSchema from './createDomainEventSchema.json'
import updateDomainEventSchema from './updateDomainEventSchema.json'
import updateLaneName from './updateLaneName.json'
import createReadModel from './createReadModel.json'
import updateReadModel from './updateReadModel.json'
import addMissingCards from './addMissingCards.json'
import regenerateCards from './regenerateCards.json'
import rollbackWorkflow from './rollbackWorkflow.json'
import updateWorkflowName from './updateWorkflowName.json'
import regenerateEntities from './regenerateEntities.json'
import addMissingEntities from './addMissingEntities.json'
import regenerateCommands from './regenerateCommands.json'
import addMissingCommands from './addMissingCommands.json'
import planWorkflowWithAI from './planWorkflowWithAI.json'
import analyzeDomainModel from './analyzeDomainModel.json'
import validateDomainModel from './validateDomainModel.json'
import addMissingReadModels from './addMissingReadModels.json'
import regenerateReadModels from './regenerateReadModels.json'
import updateEventDescription from './updateEventDescription.json'
import generateCardsFromDescription from './generateCardsFromDescription.json'
import generateEntitiesFromDescription from './generateEntitiesFromDescription.json'
import generateCommandsFromDescription from './generateCommandsFromDescription.json'
import generateReadModelsFromDescription from './generateReadModelsFromDescription.json'

const tools = [
  moveLane,
  voteCard,
  createLane,
  deleteLane,
  createCard,
  updateCard,
  deleteCard,
  createEvent,
  deleteEvent,
  createEntity,
  updateEntity,
  deleteEntity,
  createCommand,
  updateCommand,
  createDomainEventSchema,
  updateDomainEventSchema,
  updateLaneName,
  createReadModel,
  updateReadModel,
  addMissingCards,
  regenerateCards,
  rollbackWorkflow,
  updateWorkflowName,
  regenerateEntities,
  addMissingEntities,
  regenerateCommands,
  addMissingCommands,
  planWorkflowWithAI,
  analyzeDomainModel,
  validateDomainModel,
  addMissingReadModels,
  regenerateReadModels,
  updateEventDescription,
  generateCardsFromDescription,
  generateEntitiesFromDescription,
  generateCommandsFromDescription,
  generateReadModelsFromDescription
]

export default tools
